/**
 * What a failed submit means (Round 2.2 §3). Every failure is one of three:
 *
 *   retry      the request never reached a decision: no connection, a 5xx, a
 *              timeout (408) or rate limit (429). Retrying with backoff can fix it.
 *   settled    the panel no longer needs sending: it was already submitted, or it
 *              is no longer this player's (reassigned after a skip, gone).
 *   permanent  the server looked at it and said no, e.g. too detailed, malformed,
 *              the comic was abandoned. Retrying cannot help: stop, keep the
 *              drawing on the device, and tell the player what happened.
 *
 * Status 0 is how the API client reports "no answer at all".
 */
export type SubmitFailure = 'retry' | 'settled' | 'permanent';

export function classifySubmitFailure(status: number, code: string): SubmitFailure {
  if (status === 0 || status >= 500 || status === 408 || status === 429) return 'retry';
  if (code === 'already_submitted' || status === 403 || status === 404) return 'settled';
  return 'permanent';
}
